import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ru from '~/locales/ru/translation.json';
import en from '~/locales/en/translation.json';
import ar from '~/locales/ar/translation.json';
import zh from '~/locales/zh/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['ru', 'en', 'dev', 'ar', 'zh'],
    fallbackLng: 'ru',
    detection: {
      order: [
        'cookie',
        'localStorage',
        'htmlTags',
        'path',
        'subdomain',
        'queryString',
      ],
      caches: ['cookie', 'localStorage'],
    },
    debug: true,
    resources: {
      ru: { translation: ru },
      en: { translation: en },
      ar: { translation: ar },
      zh: { translation: zh },
    },
  });

export default i18n;
